import React from 'react';
import { FormattedMessage } from 'react-intl';
import style from './footer.module.scss';
import classNames from 'classnames';
import moment from 'moment';
import { ACS_PRIVACY_POLICY } from 'acscp/settings/appSettings';
import { connect } from 'react-redux';
import { AppState } from 'acscp/store';
import { userCanOnlyAccessLoyalty, userIsLoggedIn } from 'acscp/store/helpers/authHelper';

interface InjectedStateProps {
    canOnlyAccessLoyalty: boolean;
    isLoggedIn: boolean;
}

const FooterPresentational: React.FC<InjectedStateProps> = ({canOnlyAccessLoyalty, isLoggedIn}) => {
    const stickyFooterIsShowing = !canOnlyAccessLoyalty && (ENABLE_CREATE_ACCOUNT || isLoggedIn);

    return (
        <footer className={classNames(style.Footer, { [style.PadForStickyFooter]: stickyFooterIsShowing})}>
            <div className={style.FooterContainer}>
                <FormattedMessage
                    id={'components.layout.footer.disclaimer'}
                    defaultMessage={'ACS is an air charter broker. ACS is not an aircraft operator or a direct air ' +
                    'carrier and is not in operational control of aircraft. Flights will be operated by a direct air ' +
                    'carrier or direct foreign air carrier, as applicable, which will have operational control of ' +
                    'the aircraft.'}
                />
            </div>
            <div className={classNames(style.FooterContainer, style.CopyrightAndPrivacy)}>
                <span className={style.CopyRight}>
                    <FormattedMessage
                        id={'components.layout.footer.copyright'}
                        defaultMessage={'©  {year} AIR CHARTER SERVICE'}
                        values={{ year: moment().year() }}
                    />
                </span>
                <a className={style.PrivacyPolicy} href={ACS_PRIVACY_POLICY} target={'_blank'}>
                    <FormattedMessage
                        id={'components.layout.footer.privacypolicy'}
                        defaultMessage={'PRIVACY POLICY'}
                    />
                </a>
            </div>
        </footer>
    );
};

function mapStateToProps(state: AppState, ownProps: {}): InjectedStateProps {
    return {
        canOnlyAccessLoyalty: userCanOnlyAccessLoyalty(state.auth),
        isLoggedIn: userIsLoggedIn(state.auth),
    };
}

export const Footer = connect(mapStateToProps)(FooterPresentational);
